<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'ARBEITSZEIT' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <!-- User-Select für Supervisoren -->
    @if (isSupervisor() && userDropdownOptions().length > 0) {
      <div class="margin-bottom-16">
        <work-ui-select
          (valueChanged)="onUserChange($event)"
          [options]="userDropdownOptions()"
          [value]="selectedUserId()"
          label="MITARBEITER" />
      </div>
    }

    <!-- Stundensaldo -->
    @if (projectedBalance(); as projectedBalance) {
      <sfg-app-arbeitszeit-stundensaldo [balance]="projectedBalance" />
    }

    <!-- Kalenderwochen-Navigation -->
    <div class="flex flex-column gap-4 margin-bottom-16">
      <div class="flex flex-row vertical-center space-between">
        <work-ui-button
          (buttonClick)="goToPreviousWeek()"
          [iconOnly]="true"
          iconName="chevron_left"
          size="small"
          variant="secondary" />
        @if (currentWeekLabel(); as weekLabel) {
          <h3>{{ 'KW_JAHR' | translate: weekLabel }}</h3>
        }
        <work-ui-button
          (buttonClick)="goToNextWeek()"
          [iconOnly]="true"
          iconName="chevron_right"
          size="small"
          variant="secondary" />
      </div>
      <p class="work-text-align-center work-text-color-light">
        @if (currentWeekDateRange(); as weekDateRange) {
          <small>{{ 'DATUM_BIS_DATUM' | translate: weekDateRange }}</small>
        }
      </p>
    </div>

    <div class="flex flex-column gap-8">
      @for (groupedByDate of timerecorddetails(); track groupedByDate.date) {
        <sfg-app-arbeitszeit-tageskarte
          (createClick)="createForTimerecord($event)"
          (deleteClick)="deleteTimerecorddetail($event)"
          (editClick)="editTimerecorddetail($event)"
          (reapplyPauseClick)="reapplyPauseTemplate($event)"
          (resetDayClick)="resetDay($event)"
          [groupedByDate]="groupedByDate" />
      }
    </div>
  </div>
</ion-content>
<sfg-app-arbeitszeit-create-update-modal #arbeitszeitCreateUpdateModal
                                         (saved)="loadTimerecorddetails()"
                                         [timerecord]="selectedTimerecord()"
                                         [timerecorddetailToUpdate]="selectedTimerecorddetail()" />
